<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { formatPercent } from 'kanban/helper/reportFormatters';

const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  value: {
    type: String,
    required: true,
  },
  icon: {
    type: String,
    default: '',
  },
  // { direction: 'up'|'down'|'flat', ratio: Number } (computeTrend) ou null
  trend: {
    type: Object,
    default: null,
  },
  // Metrica em que subir e ruim (ex.: sem resposta) inverte a cor do delta
  invert: {
    type: Boolean,
    default: false,
  },
  // Rota de drill-in: o numero clicavel leva a lista filtrada
  to: {
    type: Object,
    default: null,
  },
  accent: {
    type: Boolean,
    default: false,
  },
});

const { t, locale } = useI18n();

const trendClass = computed(() => {
  if (!props.trend || props.trend.direction === 'flat')
    return 'text-n-slate-10';
  const positive =
    props.trend.direction === 'up' ? !props.invert : props.invert;
  return positive ? 'text-n-teal-11' : 'text-n-ruby-11';
});

const trendIcon = computed(() => {
  if (!props.trend || props.trend.direction === 'flat') return 'i-lucide-minus';
  return props.trend.direction === 'up'
    ? 'i-lucide-trending-up'
    : 'i-lucide-trending-down';
});
</script>

<template>
  <component
    :is="to ? 'router-link' : 'div'"
    :to="to || undefined"
    class="flex flex-col gap-2 p-[18px] border rounded-2xl border-n-weak bg-white dark:bg-n-solid-2 min-w-0"
    :class="{
      'transition-colors hover:border-n-strong cursor-pointer': to,
    }"
  >
    <span class="flex items-center gap-1.5 text-xs font-medium text-n-slate-10">
      <i v-if="icon" :class="icon" class="w-4 h-4 flex-shrink-0" />
      <span class="truncate">{{ label }}</span>
    </span>
    <span
      class="text-[26px] leading-none font-bold tracking-[-0.02em]"
      :class="accent ? 'text-n-amber-11' : 'text-n-slate-12'"
    >
      {{ value }}
    </span>
    <span
      class="flex items-center gap-1 text-xs min-h-[1rem]"
      :class="trendClass"
    >
      <template v-if="trend">
        <i :class="trendIcon" class="w-3.5 h-3.5" />
        {{ formatPercent(trend.ratio, locale) }}
        <span class="font-normal text-n-slate-10">
          {{ t('VINCTO_HOME.KPI.VS_PREVIOUS') }}
        </span>
      </template>
    </span>
  </component>
</template>
